
import ContextMenu from '@/components/Folders/Menus/ContextMenu'
import ContextMenuItem from '@/components/Folders/Menus/ContextMenuItem'

export default {
    name: 'FilesystemActions',
    components: { ContextMenuItem, ContextMenu },
    props: {},
    data () {
        return {
            text: ''
        }
    },
    computed: {
        folder () {
            return this.$store.getters['folders/getFolder']
        },
        roots () {
            return this.$store.getters['folders/getRootFolders']
        }
    },
    mounted () {
        this.text = this.$route.query.search
    },
    methods: {
        search () {
            this.$emit('search', this.text)
            this.$store.commit('folders/setSearchText', this.text)
            this.$refs.contextMenu.close()
        },
        showRoot (root) {
            this.$refs.contextMenu.close()
            if (this.$store.getters['folders/getActiveRootFolder']?.id === root.id) {
                return
            }
            this.$emit('list', root)
        }
    }
}
